import {
  Admin as RaAdmin,
  CustomRoutes,
  Resource,
  type TranslationMessages,
  resolveBrowserLocale
} from 'react-admin'
import { useMediaQuery } from '@mui/material'
import polyglotI18nProvider from 'ra-i18n-polyglot'
import { Route } from 'react-router-dom'
import log from 'loglevel'
import React from 'react'
import { Login } from 'ra-auth-cognito'

import { ja } from './translations-ja'
import { DataProvider } from 'components/DataProvider'
import { Dashboard } from 'components/Dashboard'
import { Layout } from 'components/Layout'
import { cognitoAuthProvider } from 'components/Auth'
import { adminTheme, desktopTtheme, otherTheme } from 'components/Theme'
import { type Partner } from '@mzc-watchover/adminapp-appsync'
import { isNil } from 'lodash/fp'

log.setLevel(log.levels.DEBUG)

const translations: Record<string, TranslationMessages> = { ja }

const i18nProvider = polyglotI18nProvider(
  (locale) => translations[locale] as TranslationMessages,
  resolveBrowserLocale(),
  [{ locale: 'ja', name: '日本語' }]
  // { allowMissing: true }
)

export const Admin: React.FC = () => {
  const isDesktop = useMediaQuery('(min-width: 900px)')
  const [partner, setPartner] = React.useState<Partial<Partner> | undefined>(
    undefined
  )
  const dataProvider = DataProvider(
    !isNil(partner) ? (partner.id as string) : undefined
  )
  const getPartner = (): Partial<Partner> | undefined => partner
  return (
    <RaAdmin
      dataProvider={dataProvider}
      i18nProvider={i18nProvider}
      authProvider={cognitoAuthProvider}
      loginPage={Login}
      requireAuth
      layout={Layout}
      lightTheme={isDesktop ? desktopTtheme : otherTheme}
      darkTheme={adminTheme}>
      <Resource name="organizations" />
      <CustomRoutes>
        <Route
          path="/"
          element={
            <Dashboard setPartner={setPartner} getPartner={getPartner} />
          }
        />
        <Route path="/:cognito" element={<Dashboard />} />
      </CustomRoutes>
    </RaAdmin>
  )
}
